import HomeCard from "../../../UI/HomeCard";

const IntroSection = () => {
  return (
    <HomeCard>
      <h5>
        A Software Engineer with experience across web development, backend
        systems, and AWS.
      </h5>

      <p>
        I primarily work on building dynamic, high-performance, and scalable web
        applications using modern frontend technologies, while also contributing
        to backend functionalities and cloud-based deployments.
      </p>

      <p>
        My current toolset includes JavaScript (ES6+), React, Next.js, Node.js,
        Express.js, basic AWS services, GitHub Actions, Docker (basic), and
        modern frontend libraries and frameworks.
      </p>

      <div>
        <h6>I can help you with the following areas:</h6>
        <ul>
          <li>Developing and maintaining modern frontend web applications</li>
          <li>Building and integrating backend APIs</li>
          <li>Managing content-driven applications using CMS platforms</li>
          <li>Basic CI/CD setup and deployment workflows</li>
          <li>Cloud-based application hosting and optimization</li>
        </ul>
      </div>
    </HomeCard>
  );
};

export default IntroSection;
